import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import AuthUser from '../pageauth/AuthUser';
import { Toaster, toast } from 'sonner';
import { DescargarApp } from '../componentes/Cuerpos/DescargarApp';
import PuenteApi from '../pageauth/PuenteApi';
import Mensaje from '../Mensaje';
import Config from '../Config';


export const LayoutHome = () => {
  const { getRol, getModule } = AuthUser()
  const { IniciarSession, ObtenerModulos } = PuenteApi()
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const { SetMensaje } = Mensaje();
  const [moduloSeleccionado, setModuloSeleccionado] = useState(null);

  useEffect(() => {
    if (getRol() === "client") {
      if (getModule() == "Remotework" || getModule() == "remotework") {
        navigate('/remotework');
      }
      if (getModule() == "Playa" || getModule() == "playa") {
        navigate('/playa');
      }
      if (getModule() == "Shop" || getModule() == "shop") {
        navigate('/shop');
      }
    }
  }, [])

  const [modulos, setModulos] = useState([
    { id: "-1", nombre: "Cargando modulos...", sector: "0", icono: "fa fa-spinner text-4xl text-red-500 mr-2" },
  ]);

  const ObtenerModulos2 = async () => {
    if (getRol() != "admin" && getRol() != "client") {
      try {
        const response = await ObtenerModulos();
        if (response && Array.isArray(response) && response.length > 0) {
          const modulos = response.map((modulo) => ({
            id: modulo.id,
            nombre: modulo.nombre,
            sector: modulo.sector,
            icono: modulo.nombre === 'Remotework' ? 'fas fa-building text-4xl text-red-500 mr-2' : (modulo.nombre === 'Playa' ? 'fas fa-gas-pump text-4xl text-red-500 mr-2' : (modulo.nombre === 'Shop' ? 'fas fa-store text-4xl text-red-500 mr-2' : 'fas fa-question')),
          }));
          setModulos(modulos);
        } else {
          SetMensaje("Error", "No se encontraron modulos", 3000);
          setModulos([{ id: "-1", nombre: "Error al cargar modulos", sector: "0", icono: "fa fa-exclamation-triangle text-4xl text-red-500 mr-2" }]);
        }
      } catch (error) {
        SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
      }
    }
  };

  useEffect(() => {
    ObtenerModulos2();
  }, []);


  const validateFields = () => {
    if (!user || !password) {
      SetMensaje("Error", "Por favor, completa todos los campos", 3000);
      return false;
    }
    if (password.length <= 5) {
      SetMensaje("Error", "La contraseña debe tener más de 5 caracteres", 3000);
      return false;
    }
    return true;
  };

  const Login = async (idmodulo) => {

    const valido = validateFields();
    if (valido) {
      console.log("idmodulo", idmodulo);
      console.log("modulos", modulos);
      const id = Number(idmodulo); // ← aquí

      const modulo = modulos.find(m => m.id === id);

      if (modulo && modulo.nombre && modulo.sector !== undefined) {

        SetMensaje("Cargando", "Iniciando sesión en " + modulo.nombre + modulo.sector + "...");

        IniciarSession(user, password, modulo.nombre, modulo.sector);
      } else {
        SetMensaje("Error", "Módulo seleccionado no es válido", 3000);
      }
    }
  };

  const abrirModulo = (id) => {
    if (id != "-1") {
      setModuloSeleccionado(id);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      Login(moduloSeleccionado);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [moduloSeleccionado, user, password]);

  if (!moduloSeleccionado) {
    return (
      <>
        <Toaster expand visibleToasts={1} />
        <div className="bg-gray-50 font-[Inter] flex items-center justify-center min-h-screen">
          <div className="text-center">
            <h1 className="text-2xl font-semibold text-gray-800 mb-10">
              Seleccione que módulo del <br />
              sistema que desea abrir
            </h1>

            <div className="flex flex-wrap justify-center gap-8 d-flex flex-wrap justify-content-center gap-4">
              {modulos.map((m) => (
                <button
                  key={m.id}
                  onClick={() => abrirModulo(m.id)}
                  className="bg-white border border-gray-200 rounded-lg shadow-sm w-40 h-40 flex items-center justify-center hover:border-teal-500 transition btn btn-light d-flex align-items-center justify-content-center flex-column"
                  style={{ width: '10rem', height: '10rem', backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
                >
                  <i className={`${m.icono} text-4xl text-red-500 mb-3`} style={{ fontSize: '2.25rem', color: '#ef4444', marginBottom: '0.75rem' }}></i>
                  <p className="text-gray-700 font-medium mb-0" style={{ color: '#374151', fontWeight: 500 }}>{m.nombre} {m.sector > 0 && m.sector}</p>
                </button>
              ))}
            </div>

            <p className="text-xs text-gray-400 mt-10">
              LiderGas - Sistema de gestion ©
            </p>
          </div>
        </div>
      </>
    );
  }

  // --- Vista 2: Login ---
  return (
    <>
      <Toaster expand visibleToasts={1} />
      <div className="bg-gray-50 font-[Inter] flex items-center justify-center min-h-screen d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
        <div className="bg-white shadow-md rounded-lg p-10 flex items-center space-x-12 card shadow-lg p-5 d-flex flex-row align-items-center gap-4" style={{ backgroundColor: 'white', borderRadius: '0.5rem' }}>
          {/* Logo */}
          <div className="flex flex-col items-center">
            <img
              src="/img/logo.webp"
              alt="Sistema de Gestión "
              height="60px"
              width="150px"
              className="mb-3"
            />
            {/* <p className="text-sm text-gray-500 italic">Sistema de gestion</p> */}
          </div>

          {/* Formulario */}
          <div>
            {/* <h2 className="text-xl font-semibold mb-6 text-gray-800">
              {moduloSeleccionado}
            </h2> */}

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nombre de Usuario
              </label>
              <input
                type="text"
                className="border border-gray-300 rounded-md w-64 px-2 py-1 focus:outline-none focus:ring-2 focus:ring-teal-500"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contraseña
              </label>
              <input
                type="password"
                className="border border-gray-300 rounded-md w-64 px-2 py-1 focus:outline-none focus:ring-2 focus:ring-teal-500"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                required
              />
            </div>

            <div className="flex justify-between">
              <button
                className="flex items-center gap-2 bg-green-100 text-green-700 border border-green-400 px-4 py-1 rounded hover:bg-green-200"
                onClick={() =>
                  Login(moduloSeleccionado)
                }
              >
                <i className="fas fa-check-circle"></i> Aceptar
              </button>

              <button
                className="flex items-center gap-2 bg-red-100 text-red-700 border border-red-400 px-4 py-1 rounded hover:bg-red-200"
                onClick={() => setModuloSeleccionado(null)}
              >
                <i className="fas fa-times-circle"></i> Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}